module.exports = __webpack_public_path__ + "img/service04.00743b3a.png";